import { render, staticRenderFns } from "./ListadoNoticias.vue?vue&type=template&id=a5ab472c&scoped=true"
import script from "./ListadoNoticias.vue?vue&type=script&lang=js"
export * from "./ListadoNoticias.vue?vue&type=script&lang=js"
import style0 from "./ListadoNoticias.vue?vue&type=style&index=0&id=a5ab472c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ab472c",
  null
  
)

export default component.exports